import React from 'react';
import { Grid3x3Gap, Table } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';

/** Segmented Cards / Table toggle for desktop journal list. */
export default function TradeJournalViewToggle({ value, onChange }) {
  const { colors } = useTheme();

  const options = [
    { id: 'cards', label: 'Cards', Icon: Grid3x3Gap },
    { id: 'table', label: 'Table', Icon: Table },
  ];

  return (
    <div
      role="group"
      aria-label="Journal list view"
      style={{
        display: 'inline-flex',
        padding: 3,
        gap: 2,
        borderRadius: 8,
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.bgPrimary,
      }}
    >
      {options.map(({ id, label, Icon }) => {
        const active = value === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            aria-pressed={active}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 12px',
              borderRadius: 6,
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: active ? 600 : 500,
              cursor: 'pointer',
              color: active ? colors.text : colors.textMuted,
              backgroundColor: active ? colors.bgSecondary : 'transparent',
              transition: 'background-color 0.15s ease, color 0.15s ease',
            }}
          >
            <Icon size={14} aria-hidden />
            {label}
          </button>
        );
      })}
    </div>
  );
}
